var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaimRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.673 12.348v5.748c-1.429 0-2.837.04-4.223-.04-.61 0-.715-.385-.715-.79-.02-1.62 0-3.238 0-4.918h4.938zm.819 5.788v-5.788h4.916v4.938c0 .587-.483.85-1.05.85h-3.866zm-.42-10.929c.462-.547.84-1.073 1.302-1.559.652-.688 1.492-.81 2.227-.405.694.385 1.072 1.174.883 1.903-.231.83-.84 1.295-1.828 1.315-1.744.02-3.488.02-5.231 0-.967-.02-1.555-.485-1.765-1.356-.168-.708.168-1.457.84-1.842.735-.425 1.513-.344 2.185.304.483.506.903 1.073 1.387 1.64zm-.546.546c-.547-.668-.883-1.235-1.387-1.64-.294-.222-.883-.344-1.219-.202-.294.122-.651.526-.546 1.032.063.344.567.668.925.75.65.161 1.323.06 2.226.06zm1.092.02c.924.04 1.597.081 2.206-.06.651-.142.882-.547.945-.911.042-.263-.168-.75-.525-.89-.336-.143-.924-.041-1.197.181-.526.385-1.03 1.194-1.429 1.68z",
    fill: "#fff",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.672 9.23v2.328H7.681C6.378 11.558 6 11.7 6 10.242c0-.425.084-.991.882-1.011 1.555-.041 3.11 0 4.79 0zm.82 2.328V9.231c1.68 0 3.32-.02 4.958.02.63.04.546.81.546.85 0 1.64-.189 1.477-1.639 1.457h-3.865z",
    fill: "#fff",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 0,
    x2: -0.598,
    y2: 0.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE995"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimRewards);
export default __webpack_public_path__ + "static/media/claimRewards.4ed9e2ebde14acbfd64f96da133db136.svg";
export { ForwardRef as ReactComponent };